import * as React from "react";
import { isRedesignEnabled } from "./flag";

/**
 * Render `Redesign` when the redesign flag is on, otherwise `Legacy`.
 *
 * Lets every PR ship a redesign sibling without touching legacy code.
 *
 * Usage:
 *   const Page = pickPage(LegacyHomepage, RedesignHomepage);
 *   <Route path="/" element={<Page />} />
 */
export function pickPage<P extends object>(
  Legacy: React.ComponentType<P>,
  Redesign: React.ComponentType<P>
): React.ComponentType<P> {
  const Picked: React.FC<P> = (props) => {
    const C = isRedesignEnabled() ? Redesign : Legacy;
    return <C {...(props as P)} />;
  };
  Picked.displayName = `pickPage(${
    (Redesign as { displayName?: string }).displayName ?? Redesign.name ?? "Redesign"
  })`;
  return Picked;
}
